import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/api';

export const useTreatmentStats = (dateRange?: { start_date?: string; end_date?: string }) => {
  return useQuery({
    queryKey: ['treatment-stats', dateRange],
    queryFn: () => analyticsApi.getTreatmentStats(dateRange),
  });
};